import Modal from '../modal/Modal'
import { Icon } from '@iconify/react'
import TagPicker from './TagPicker'
import './tags.scss'

type Props = {
  kind: 'booking' | 'floating' | 'cancelled'
  shipmentId: string
  value?: string[]
  onChange?: (tagIds: string[]) => void
  onClose: () => void
  title?: string
}

/**
 * TagPicker in a modal, for list screens where a shipment has no detail page
 * of its own to hang the picker off — cancelled bookings link through to the
 * parent booking, so tagging the cancellation record needs its own affordance.
 */
function TagEditModal({
  kind,
  shipmentId,
  value,
  onChange,
  onClose,
  title = 'Tags',
}: Props) {
  return (
    <Modal>
      <div className='left-modal'>
        <div className='modal-top flex justify-between items-center'>
          <h2>{title}</h2>
          <div className='close flex items-center justify-center'>
            <Icon icon='line-md:close' onClick={onClose} />
          </div>
        </div>
        <div className='form'>
          <div className='input-card'>
            <p>Tap a tag to apply or remove it. Changes save immediately.</p>
            <br />
            <TagPicker
              kind={kind}
              shipmentId={shipmentId}
              value={value}
              onChange={onChange}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default TagEditModal
